export const environment = {
  animation: true,
  transitionTimerDelayMs: 5,
};
